export default function GetRandomTagLine(): string {
	const strings = [
		"Fueling up faster than a Falcon 9!",
		"Receiving stock, one booster landing at a time.",
		"Counting down... T-minus stock arrival!",
		"Stock Wars: The Inventory Awakens.",
		"We’re gonna need a bigger warehouse...",
		"May the stock be with you.",
		"Life is like a box of stock... you never know what you're gonna receive!",
		"🌙 Receiving has entered the dark side... with Dark Mode in Settings!",
	];

	let index = Math.floor(Math.random() * strings.length);
	return strings[index];
}
